// Library methods

// Utils
import { POST, GET } from '../../../utils/fetchWrappers';

// API URLs
import {
    API_UPDATE_PROFILE,
    API_FETCH_MERCHANT_PROFILE,
    API_DELETE_PROFILE,
    API_SDK_JSON,
    API_CREATE_STATIC_QR,
} from '../../../utils/API/apiUrls';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import * as profileActions from './profile.actions';

// Constants
import {
    FETCH_PROFILE_REQUEST,
    UPDATE_IMAGE_REQUEST,
    DELETE_IMAGE_REQUEST,
    FETCH_PROFILE_JSON_REQUEST,
    CREATE_STATIC_QR_REQUEST,
} from './profile.constants';
import { toast } from 'react-toastify';
import { takeLatest, put, call } from 'redux-saga/effects';

export function* fetchUserProfile(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_FETCH_MERCHANT_PROFILE, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(profileActions.fetchProfileDetailsSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                profileActions.fetchProfileDetailsError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        if (data && data.errorMessage) {
            yield put(
                profileActions.fetchProfileDetailsError({
                    error: data.errorMessage,
                })
            );
        }
    }
    yield put(loaderActions.hideLoader());
}

export function* updateUserImage(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(
            POST,
            API_UPDATE_PROFILE,
            payload,
            {
                'Content-Type': 'multipart/form-data',
            },
            true
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(profileActions.updateImageSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                profileActions.updateImageError({
                    error: data.errorMessage,
                })
            );
            toast.info(data.errorMessage);
        }
    } catch (error) {
        if (error.response) {
            const { data } = error.response;
            if (data && data.errorMessage) {
                yield put(
                    profileActions.updateImageError({
                        error: data.errorMessage,
                    })
                );
                toast.info(data.errorMessage);
            }
        } else {
            yield put(profileActions.resetImageRequest());
            toast.info('Something went wrong. Please try again.');
        }
    }
    yield put(loaderActions.hideLoader());
}

export function* deleteUserImage(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { data } = yield call(POST, API_DELETE_PROFILE);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(profileActions.deleteImageSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                profileActions.deleteImageError({
                    error: data.errorMessage,
                })
            );
            toast.info(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        if (data && data.errorMessage) {
            yield put(
                profileActions.deleteImageError({ error: data.errorMessage })
            );
            toast.info(data.errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

export function* getProfileJsonDetails() {
    yield put(loaderActions.showLoader());
    try {
        const { data } = yield call(GET, API_SDK_JSON);
        if (data) {
            yield put(profileActions.fetchProfileJSONSuccess(data));
        }
    } catch (response) {
        yield put(profileActions.fetchProfileJSONError());
        toast.info('Something went wrong with sdk data.');
    }
    yield put(loaderActions.hideLoader());
}

export function* createStaticQR(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_CREATE_STATIC_QR, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(profileActions.createStaticQrSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                profileActions.createStaticQrError({
                    error: data.errorMessage,
                })
            );
            toast.info(data.errorMessage);
        }
    } catch (error) {
        if (error.response) {
            const { data } = error.response;
            if (data && data.errorMessage) {
                yield put(
                    profileActions.createStaticQrError({
                        error: data.errorMessage,
                    })
                );
                toast.info(data.errorMessage);
            }
        } else {
            toast.info('Something went wrong. Please try again.');
        }
    }
    yield put(loaderActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* profileSaga() {
    yield takeLatest(FETCH_PROFILE_REQUEST, fetchUserProfile);
    yield takeLatest(UPDATE_IMAGE_REQUEST, updateUserImage);
    yield takeLatest(DELETE_IMAGE_REQUEST, deleteUserImage);
    yield takeLatest(FETCH_PROFILE_JSON_REQUEST, getProfileJsonDetails);
    yield takeLatest(CREATE_STATIC_QR_REQUEST, createStaticQR);
}
